(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/statistics/navbig/assets/javascripts/views/nav-big-region.js') >= 0) return;  svs.modules.push('/components/statistics/navbig/assets/javascripts/views/nav-big-region.js'); 

(function(svs, Backbone, _) {
  'use strict';

  svs.statistics = svs.statistics || {};
  svs.statistics.big = svs.statistics.big || {};
  svs.statistics.big.NavBigRegion = svs.statistics.big.NavBigRegion || {};

  svs.statistics.big.NavBigRegion = Backbone.Marionette.Region.extend({
    isAnimating: false,
    animationSpeed: 200,
    animateTo: 'left',
    log: new svs.core.log.Logger('svs.statistics.big.NavBigRegion'),
    initialize: function() {},
    setScrollSelector: function(selector) {
      this.scrollerSelector = selector;
    },

    setAnimationDirection: function(direction) {
      this.animateTo = direction;
    },

    ensureElement: function() {
      this.$el = this.getEl(this.el);
      this.el = this.$el[0];
    },
    show: function(view) {
      this.ensureElement();
      this.view = view;
      this.showContinue();
    },
    swapToBack: function(regionBack) {
      if (!this.view) return;
      regionBack.ensureElement();

      regionBack.$el.css(this.animateTo, 0);
      regionBack.$el.html(this.view.el);
      regionBack.view = this.view;
      regionBack.customCurrentView = this.view;

      this.customCurrentView = null;
    },
    swapToFront: function(regionFront, view) {
      if (!view) {
        return;
      }
      if (view) {
        this.view = view;
      }

      regionFront.ensureElement();
      regionFront.$el.css(this.animateTo, 0);
      regionFront.$el.html(this.view.el);
      regionFront.view = this.view;
      regionFront.customCurrentView = this.view;

      this.customCurrentView = null;
    },
    showContinue: function() {
      var view = this.view;

      if (_.isFunction(view.triggerMethod)) {
        view.triggerMethod('before:render');
      }

      this.customCurrentView = view;
      view.render();

      return this;
    },
    open: function(options) {
      if (!this.customCurrentView) {
        return;
      }

      this.$el.html(this.customCurrentView.el);

      this.$el.width(this.$el.get(0).clientWidth);

      this.$el.css(this.animateTo, this.$el.get(0).clientWidth);

      this.displayRegion(true);

      if (options.skippAnim) {
        this.$el.css(this.animateTo, 0);
        this.showDone();
        return;
      }

      this.isAnimating = true;
      var _self = this;
      var animateCss = {
        left: 0,
        useTranslate3d: true
      };

      if (this.animateTo === 'right') {
        animateCss = {
          right: this.$el.get(0).clientWidth,
          useTranslate3d: true
        };
      }

      this.$el.animate(animateCss, this.animationSpeed, 'easeOut', function() {
        _self.showDone();
      });
    },
    openBackRegion: function(view) {
      this.ensureElement();
      this.view = view;
      this.showContinue();
    },
    showDone: function() {
      this.isAnimating = false;
      this.$el.width('100%');
      this.trigger(
        'openRegionDone',
        this.$el,
        this.customCurrentView ? this.customCurrentView.el : null
      );

      this.forceRender();
    },
    forceRender: function() {
      var rightColumn = $('.nav-big');

      if (rightColumn) {
        rightColumn.css('opacity', 0.99);
        setTimeout(function() {
          rightColumn.css('opacity', 1);
        }, 0);
      }
    },
    empty: function(emptyOptions) {
      var _self = this;
      this.emptyOptions = emptyOptions;

      if (!this.$el || (this.$el && !this.$el.length)) {
        this.emptyAndRemove();
        if (_self.emptyOptions && _self.emptyOptions.cbHandler) {
          this.trigger(this.emptyOptions.cbHandler, this.emptyOptions);
        }
        return;
      }

      var animateCss = { useTranslate3d: true };
      animateCss[this.animateTo] = this.$el.get(0).clientWidth;

      var leftStr = this.$el.css(this.animateTo);
      leftStr = leftStr.substr(0, leftStr.length - 2);

      if (
        parseInt(leftStr, 10) !== this.$el.get(0).clientWidth &&
        emptyOptions &&
        !emptyOptions.skippAnim
      ) {
        this.isAnimating = true;
        this.$el.animate(
          animateCss,
          this.animationSpeed,
          'easeOut',
          function() {
            _self.emptyDone();
          }
        );
      } else {
        if (!emptyOptions) {
          this.emptyAndRemove();
        } else {
          this.emptyDone();
        }
      }
    },
    emptyAndRemove: function() {
      var view = this.customCurrentView;
      if (!view || view.isDestroyed()) {
        return;
      }

      if (view.destroy) {
        view.destroy();
      } else if (view.remove) {
        view.remove();
      }


      this.customCurrentView = null;
      delete this.customCurrentView;
    },
    emptyDone: function() {
      this.isAnimating = false;
      this.emptyAndRemove();

      if (this.emptyOptions && this.emptyOptions.event) {
        this.trigger(this.emptyOptions.event);
        this.emptyOptions.event = null;
      }

      if (this.emptyOptions.cbHandler !== 'continue-show-modal') {
        this.trigger('openRegionDone', this.$el);
      }

      if (this.emptyOptions && this.emptyOptions.cbHandler) {
        this.trigger(this.emptyOptions.cbHandler, this.emptyOptions);

        if (this.emptyOptions.cbHandler === 'swap-to-front') {
          var oElement = this.emptyOptions.rmElement;
          if (_.isObject(oElement)) {
            var _self = this;
            if (_.has(oElement, 'teamId')) {
              this.emptyOptions.teamId = oElement.teamId;
              _self.trigger('region-back:show-team', this.emptyOptions);
            } else if (_.has(oElement, 'leagueId')) {
              this.emptyOptions.leagueId = oElement.leagueId;
              _self.trigger('region-back:show-league', this.emptyOptions);
            } else if (_.has(oElement, 'matchId')) {
              this.emptyOptions.matchId = oElement.matchId;
              _self.trigger('region-back:show-match', this.emptyOptions);
            }
          }
        }
      }
    },
    displayRegion: function(tVisible) {
      if (!this.$el || (this.$el && !this.$el.length)) return;

      this.$el.css({ visibility: tVisible ? 'visible' : 'hidden' });
      this.$el.css({ opacity: tVisible ? '1' : '0' });
    },
    displayTempRegion: function(tVisible) {
      this.displayBackRegion(tVisible);
    },
    displayBackRegion: function(tVisible) {
      if (!this.$el || (this.$el && !this.$el.length)) return;

      this.$el.removeAttr('style');
      this.$el.removeClass('no-height');

      if (!tVisible) this.$el.addClass('no-height');
      this.displayRegion(tVisible);
    },
    beforeNavigation: function(tDisplay, noHeight) {
      if (!this.$el || (this.$el && !this.$el.length)) return;

      this.$el.removeClass('position-nav');
      this.$el.removeClass('position-standard');

      if (tDisplay) {
        this.$el.addClass('position-nav');
      } else {
        this.$el.addClass('position-standard');
        if (!noHeight) {
          this.$el.css({ height: 'auto' });
        }
      }
    }
  });
})(svs, Backbone, _);

 })(window);